import React, { useEffect, useState } from 'react';
import { BeakerIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/react/solid'
const ProjectImageSlider = ({ images }) => {
    const [image, setImage] = useState('')
    const [count, setCount] = useState(0)

    useEffect(() => {
        if (!image && images?.length > 0) {
            setImage(images[count])
        }
    }, [images])

    useEffect(() => {
        if (images?.length > 0) {
            setImage(images[count])
        }
    }, [count, images])

    const handleCount = (num) => {
        const newCount = count + num;
        const imgLength = images?.length
        if (newCount < 0) {
            setCount(imgLength - 1)
        } else if (newCount > imgLength - 1) {
            setCount(0)
        } else {
            setCount(newCount)
        }
    }

    return (
        <div className='w-100 p-3'>
            <div className="row align-items-center">
                <div className="col-1">
                    <ChevronDoubleLeftIcon onClick={() => handleCount(-1)} className=" text-secondary mt-5 navigate-Icon" />
                </div>
                <div className="col-10">
                    <div className='w-100 slide-img'>
                        <img src={image} className='w-100' alt="" />
                    </div>
                </div>
                <div className="col-1">
                    <ChevronDoubleRightIcon onClick={() => handleCount(1)} className="h-5 w-5 text-secondary mt-5 navigate-Icon" />
                </div>
            </div>
        </div>
    );
};

export default ProjectImageSlider;